(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-tag",
        class: _vm.className,
        style: _vm.tagStyle,
        attrs: {
          "size": _vm.size
        }
      }, [_c('button', {
        staticClass: "nx-tag__inner",
        attrs: {
          "role": "option"
        }
      }, [_vm._t("default", [_vm._v(_vm._s(_vm.content))])], 2)]);
    },
    name: 'nx-tag',
    props: {
      type: {
        type: String,
        default: 'fill'
      },
      fillColor: {
        type: String,
        default: '#FF5441'
      },
      fontColor: String,
      shape: {
        type: String,
        default: 'circle'
      },
      size: {
        type: String,
        default: 'large'
      },
      content: {
        type: String,
        default: ''
      }
    },
    computed: {
      className: function className() {
        var ret = ["type-".concat(this.type)];

        if (this.shape && this.type !== 'ghost') {
          ret.push("shape-".concat(this.shape));
        }

        return ret;
      },
      tagStyle: function tagStyle() {
        var style = {};

        if (this.type === 'ghost') {
          style.color = this.fontColor || this.fillColor;
          style.borderColor = this.fillColor;
        } else {
          style.color = this.fontColor || '#fff';
          style.background = this.fillColor;
        }

        return style;
      }
    }
  };
  _exports.default = _default;
});